import { render, staticRenderFns } from "./SharedTableSettings.vue?vue&type=template&id=cf9f967c&scoped=true"
import script from "./SharedTableSettings.vue?vue&type=script&lang=js"
export * from "./SharedTableSettings.vue?vue&type=script&lang=js"
import style0 from "./SharedTableSettings.vue?vue&type=style&index=0&id=cf9f967c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9f967c",
  null
  
)

export default component.exports